export const LOAN_WAIVER_HEADER = 'Confirm Access to Documents';
export const LOAN_WAIVER_SUBTITLE = 'Please confirm that you possess the documents related to this loan.';
